export const getMessages = (state) => state.message.messages;

export const getMessagesPagination = (state) => state.message.pagination;
